import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";

import { Footer } from "../../components/Footer/Footer";
import { useSelections } from "../../context/Selections";
import KpiCard from "../../components/KpiCard/KpiCard";

const OBJECTS_IDS = {
  FOLLOW_UP: "uwphPj",
  PERFORMANCE: "mzhfeJz",
  MONTHLY_MONITORING: "vqAenZ",
  KPIS: {
    TITLE: "aMPUW",
    REALI: "ReK",
    META: "ykaSr",
    ATING: "knXBPQG",
  },
};

const OBJECTS_IDS_BIGNUMBERS = {
  BIGNUMBERS: [
    {
      TITLE: "EJsRB",
      DATE: "CbsWCFh",
      REALI: "NJPmjRB",
    },
    {
      TITLE: "nnKmN",
      DATE: "pBheUrp",
      REALI: "yRF",
    },
    {
      TITLE: "juYPpD",
      DATE: "XTEmxuK",
      REALI: "TJmBGY",
    },
  ],
};

function SellOutDLX({ app, config }) {
  const { selections } = useSelections();

  const [titleBigNumber01, setTitleBigNumber01] = useState("");

  const [titleBigNumber02, setTitleBigNumber02] = useState("");
  const [dateBigNumber02, setDateBigNumber02] = useState("");
  const [valueBigNumber02, setValueBigNumber02] = useState("");

  const [titleBigNumber03, setTitleBigNumber03] = useState("");
  const [dateBigNumber03, setDateBigNumber03] = useState("");
  const [valueBigNumber03, setValueBigNumber03] = useState("");

  const [titleBigNumber04, setTitleBigNumber04] = useState("");
  const [dateBigNumber04, setDateBigNumber04] = useState("");
  const [valueBigNumber04, setValueBigNumber04] = useState("");

  const getTitleBigNumbers = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          position === 1 && setTitleBigNumber01(value);
          position === 2 && setTitleBigNumber02(value);
          position === 3 && setTitleBigNumber03(value);
          position === 4 && setTitleBigNumber04(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  const getDateBigNumbers = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          position === 2 && setDateBigNumber02(value);
          position === 3 && setDateBigNumber03(value);
          position === 4 && setDateBigNumber04(value);
        } catch (error) {
          console.error("Erro ao buscar bignumbers:", error);
        }
      }
    },
    [app]
  );

  const getValueBigNumbers = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          let value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          position === 2 && setValueBigNumber02(value);
          position === 3 && setValueBigNumber03(value);
          position === 4 && setValueBigNumber04(value);
        } catch (error) {
          console.error("Erro ao buscar bignumbers:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getTitleBigNumbers(OBJECTS_IDS.KPIS.TITLE, 1);
      getTitleBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[0].TITLE, 2);
      getTitleBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[1].TITLE, 3);
      getTitleBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[2].TITLE, 4);
    }
  }, [app, getTitleBigNumbers, selections]);

  useEffect(() => {
    if (app) {
      getDateBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[0].DATE, 2);
      getDateBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[1].DATE, 3);
      getDateBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[2].DATE, 4);
    }
  }, [app, getDateBigNumbers, selections]);

  useEffect(() => {
    if (app) {
      getValueBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[0].REALI, 2);
      getValueBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[1].REALI, 3);
      getValueBigNumbers(OBJECTS_IDS_BIGNUMBERS.BIGNUMBERS[2].REALI, 4);
    }
  }, [app, getValueBigNumbers, selections]);

  return (
    <div className="app investigation">
      <div className="appContent">
        <LayoutWrapper>
          <Grid>
            <Card className="container-card-only-title">
              <h1 className="title">% Sell Out DLX</h1>
            </Card>
          </Grid>

          <Grid container className="container-bignumbers">
            {/* <Card
              app={app}
              header={{
                hardTitle: titleBigNumber01,
              }}
              >
            </Card> */}
            <KpiCard
              className="card-item"
              app={app}
              KPITitle={titleBigNumber01}
              valueId={OBJECTS_IDS.KPIS.META}
              goalValueId={OBJECTS_IDS.KPIS.REALI}
              percentageId={OBJECTS_IDS.KPIS.ATING}
              hasProgressBar={true}
              fullView
            />

            <Card
              app={app}
              className={"card-item"}
              header={{
                hardTitle: titleBigNumber02,
              }}
            >
              <div className="content-card">
                <p className="subtitle">{dateBigNumber02}</p>
                <p className="container-values">
                  <span className="item-value">{valueBigNumber02}</span>
                  <span className="item-text">Realizado</span>
                </p>
              </div>
            </Card>

            <Card
              app={app}
              className={"card-item"}
              header={{
                hardTitle: titleBigNumber03,
              }}
            >
              <div className="content-card">
                <p className="subtitle">{dateBigNumber03}</p>
                <p className="container-values">
                  <span className="item-value">{valueBigNumber03}</span>
                  <span className="item-text">Realizado</span>
                </p>
              </div>
            </Card>

            <Card
              app={app}
              className={"card-item"}
              header={{
                hardTitle: titleBigNumber04,
              }}
            >
              <div className="content-card">
                <p className="subtitle">{dateBigNumber04}</p>
                <p className="container-values">
                  <span className="item-value">{valueBigNumber04}</span>
                  <span className="item-text">Realizado</span>
                </p>
              </div>
            </Card>
          </Grid>

          <Grid container className="container-apuração">
            <Card
              app={app}
              header={{
                hardTitle: "Acompanhamento por Quarter",
              }}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.FOLLOW_UP}
              style={{ margin: "2.9px 0 16px 0" }}
              expandable
            >
              <div className="container-legends">
                <p className="container-item item-meta">
                  <span className="item-color color-meta" />
                  <span className="item-text">Meta</span>
                </p>

                <p className="container-item item-realizado">
                  <span className="item-color color-realizado" />
                  <span className="item-text">Realizado</span>
                </p>
              </div>

              <NativeObject
                app={app}
                key={OBJECTS_IDS.FOLLOW_UP}
                reference={{ id: OBJECTS_IDS.FOLLOW_UP }}
                style={{
                  width: "100%",
                  height: "370px",
                }}
              />
            </Card>
          </Grid>

          <Grid container className="container-apuração">
            <Card
              app={app}
              header={{
                hardTitle: "Desempenho",
              }}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.PERFORMANCE}
              style={{ margin: "2.9px 0 16px 0" }}
              expandable
            >
              <NativeObject
                app={app}
                key={OBJECTS_IDS.PERFORMANCE}
                reference={{ id: OBJECTS_IDS.PERFORMANCE }}
                style={{
                  width: "100%",
                  height: "370px",
                }}
              />
            </Card>
          </Grid>

          <Grid container className="container-apuração">
            <Card
              app={app}
              header={{
                hardTitle: "Acompanhamento Mensal",
              }}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.MONTHLY_MONITORING}
              style={{ margin: "2.9px 0 16px 0" }}
              expandable
            >
              <NativeObject
                app={app}
                key={OBJECTS_IDS.MONTHLY_MONITORING}
                reference={{ id: OBJECTS_IDS.MONTHLY_MONITORING }}
                style={{
                  width: "100%",
                  height: "370px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

SellOutDLX.defaultProps = {
  app: null,
  config: {},
};

SellOutDLX.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutDLX;
